module.exports = __webpack_public_path__ + "img/icon-activities.4037d522.svg";